import React from 'react'

import { Icon, RotatingSpinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const iconSize = { height: '100px', width: '100px' }
// Inline instead of a utility class: this overlay renders on a fast page, where the studio
// stylesheet arrives after first paint, so a CSS-hidden label would flash across the viewer
// until the rule applies. `.sr-only` is also not part of the studio bundle at all.
const visuallyHiddenStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
}

function LoadingState() {
  const t = useTranslation()

  return (
    <div className="viewer-overlay" role="status">
      <Icon svgComponent={RotatingSpinner} color="primary" size={iconSize} notSpaced />
      <span style={visuallyHiddenStyle}>{t('viewer.banner.loadingTitle')}</span>
    </div>
  )
}

export default LoadingState
